(function (angular) {
	'use strict';

	var featureObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		bindings: {
			label: '<'
		},
		controllerAs: 'reitPhaseTooltip'
	};

	angular
		.module('investorDashboard')
		.component('reitPhaseTooltip', featureObject);

	function templateUrlFunction(STATIC_BASE_PATH) {
		return STATIC_BASE_PATH + '/static/html/investor-dashboard/reit-phase-tooltip.html';
	}
})(window.angular);